import { SvgIcon } from "@material-ui/core";

export const RefreshIcon = (props) => {
  return (
    <SvgIcon
      fill="#000000"
      width="800px"
      height="800px"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M19.146 4.854l-1.489 1.489A8 8 0 1 0 12 20a8.094 8.094 0 0 0 7.371-4.886 1 1 0 1 0-1.842-.779A6.071 6.071 0 0 1 12 18a6 6 0 1 1 4.243-10.243l-1.39 1.39a.5.5 0 0 0 .354.854H19.5A.5.5 0 0 0 20 9.5V5.207a.5.5 0 0 0-.854-.353z" />
    </SvgIcon>
  );
};
